type Rect = { x: number; y: number; w: number; h: number };
type Point = { x: number; y: number };

// Keep new pages near the current work without covering an existing object.
// Reserve a full preview's height so writing does not grow into a page below it.
export function documentPosition(
  preferred: Point,
  size: { w: number; h: number },
  occupied: Rect[],
): Point {
  const gap = 64;
  const candidates = [preferred];
  for (const box of occupied) {
    const left = box.x - size.w - gap,
      right = box.x + box.w + gap;
    const above = box.y - size.h - gap,
      below = box.y + box.h + gap;
    candidates.push(
      { x: left, y: preferred.y },
      { x: right, y: preferred.y },
      { x: preferred.x, y: above },
      { x: preferred.x, y: below },
      { x: right, y: box.y },
      { x: left, y: box.y },
      { x: box.x, y: below },
      { x: box.x, y: above },
    );
  }
  candidates.sort(
    (a, b) =>
      Math.hypot(a.x - preferred.x, a.y - preferred.y) -
      Math.hypot(b.x - preferred.x, b.y - preferred.y),
  );
  const free = candidates.find((point) =>
    occupied.every(
      (box) =>
        point.x + size.w + gap <= box.x ||
        point.x >= box.x + box.w + gap ||
        point.y + size.h + gap <= box.y ||
        point.y >= box.y + box.h + gap,
    ),
  );
  return (
    free ?? {
      x: Math.max(preferred.x, ...occupied.map((b) => b.x + b.w + gap)),
      y: preferred.y,
    }
  );
}
